<template>
    <div class="profile-order-table">
        <div v-if="goods.length === 0" class="profile-order-empty">
            <img src="../../../assets/profile/empty-cart.png" alt="">
            <router-link :to="{name:'FooterShop'}">
                <p>
                    <Button  type="text" style="font-size:16px;">{{$t('shopping_card_go_to_shopping')}} <Icon type="chevron-right"></Icon></Button>
                </p>
            </router-link>
        </div>
        <div v-else>
            <div class="order-groups pc-show">
                <div class="order-header">
                    <span>
                        <Checkbox v-model="singer" style="margin-left: 8px;font-size:14px;" v-on:on-change="selectAll">{{$t('shopping_card_selected')}}</Checkbox>
                    </span>
                    <span>{{$t('user_center_order_product')}}</span>
                    <span>{{$t('user_center_order_price')}}</span>
                    <span>{{$t('user_center_order_Quantity')}}</span>
                    <span>{{$t('user_center_order_Subtotal')}}</span>
                    <span>{{$t('user_center_order_operation')}}</span>
                </div>
                <div class="order-list" v-for="(good,index) in goods">
                    <div class="order-row">
                            <div class="">
                                <Checkbox class="goods-checkbox" :label="good.id" v-model="good.if_checked">
                                    <div class="goods-header">
                                        <img :src="good.goods_img" alt="">
                                    </div>
                                </Checkbox>
                            </div>

                            <div class="goods-desc">
                                <h3>{{good.goods_name}}</h3>
                                <p>{{good.product_introduction}}</p>
                            </div>
                            <div class="goods-price">${{parseFloat(good.goods_price)}}</div>
                            <div class="goods-num">
                                <div class="goods-num-editable">
                                    <button type="button" class="minus" @click="min(index)">
                                        <Icon type="minus" size="12"></Icon>
                                    </button>
                                    <span class="number">{{good.goods_num}}</span>
                                    <button type="button" class="plus" @click="max(index)">
                                        <Icon type="plus" size="12"></Icon>
                                    </button>
                                </div>
                            </div>
                            <div class="goods-num text-primary">${{parseFloat(good.goods_price) * good.goods_num}}</div>
                            <div class="goods-operation">
                                <a href="javascript:;" @click="delect_order(index)">
                                    <Icon type="close"/>
                                </a>
                            </div>
                    </div>
                </div>
            </div>
            <div class="mobile-show"  v-for="(item,index) in goods">
                <div class="goods-header">
                    <img :src="item.goods_img">
                </div>
                <div class="goods-desc">
                    <h3>
                        {{item.goods_name}}
                        <a href="javascript:;" @click="remove_order(index)">
                            <Icon type="close"/>
                        </a>
                    </h3>
                    <p>${{item.goods_price}}</p>
                    <div class="goods-num">
                        <div class="goods-num-editable">
                            <button type="button" class="minus" @click="min(index)">
                                <Icon type="minus" size="12"></Icon>
                            </button>
                            <span class="number">{{item.goods_num}}</span>
                            <button type="button" class="plus" @click="max(index)">
                                <Icon type="plus" size="12"></Icon>
                            </button>
                            <div class="goods-price text-primary">${{item.goods_price * item.goods_num}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="prifile-order-total">
                <div class="order-total-left">
                    <router-link :to="{name:'Store'}">
                        <Button type="text" size="large">{{$t('continue_purchase')}}</Button>
                    </router-link>
                    <div class="order-calculate">
                        {{$t('total_part_2', {totalCount: cartCount,selectedCount: selectNumber})}}
                    </div>
                </div>
                <div class="order-total-right">
                    <div class="order-subtotal">
                        <span>{{$t('user_center_order_total_tip')}}:</span>
                        <span class="text-primary total-price">USD ${{totalPrice}}</span>
                    </div>
                    <Button type="primary" @click="checkOut" class="checkOut_btn">{{$t('check_out_btn')}}</Button>
                </div>
            </div>
            <guess></guess>

            <!--删除购物车订单-->
            <modal v-model="showdelect" size="small" class="canel_order" >
                <div slot="header"></div>
                <div class="page-content">
                    <div class="canel_order-title">
                        <h2>{{$t('user_center_order_cancel_order')}}</h2>
                    </div>
                    <div class="canel_order_content">
                        <p> {{$t('if_delect_order_content')}}</p>
                    </div>
                    <div class="canel_order-btn">
                        <button @click="showdelect = false">{{$t('if_delect_lookat_btn')}}</button>
                        <button @click="remove_order()" class="ok_btn">{{$t('determine_btn')}}</button>
                    </div>
                </div>
                <div slot="footer"></div>
            </modal>

        </div>
        <Spin size="large" fix v-if="spinShow"></Spin>
    </div>

</template>
<script>

    import guess from '../Common/Guess.vue'
    import Signature from '../../../lib/Signature'
    import modal from '../../Common/Modal.vue'

    export default {
        data () {
            return {
                singer:true,
                showdelect:false,
                selectList: [],
                goods_index:0,
                goods: [],
                spinShow: false
            }
        },
        components: {
            guess,modal
        },
        created () {
            this.spinShow = true
            let module = 'index.php/index/shopcar/carinfo'
            let data = {}
            data.sub_time = Signature.timestamp()
            data.sign = Signature.create(module, data.sub_time)
            data.user_id = this.Local.getUserId()
            data.token = this.Local.getUserToken()
            data.lang = this.$i18n.locale
            this.$http.get(process.env.BASEURL + module, {params: data})
            .then(function (response) {
                this.goods = response.data.data
                console.log(response.data)
                this.spinShow = false
            }.bind(this))
        },
        computed: {
            totalPrice () {
                let temp = 0
                for (let item of this.goods) {
                    if (item.if_checked) {
                        temp += parseFloat(item.goods_price) * item.goods_num
                    }
                }
                return temp
            },
            cartCount () {
                return this.goods.length
            },
            selectNumber () {
                let temp = 0
                for (let item of this.goods) {
                    if (item.if_checked) {
                        temp += 1
                    }
                }
                return temp
            }
        },
        methods: {
            delect_order(index){
                this.showdelect = true
                this.goods_index = index
            },
            checkOut () {
                if (this.totalPrice === 0) {
                    this.$Message.error(this.$t('user_message_please_choose_product'))
                    return false
                }

                let data = {}

                data.goods_id = []
                data.number = []
                for (let item of this.goods) {
                    if (item.if_checked === true) {
                        data.goods_id.push(item.goods_id)
                        data.number.push(item.goods_num)
                    }
                }
                data.goods_id = data.goods_id.join(',')
                data.number = data.number.join(',')

                this.$router.push({
                    name: 'Settlement',
                    query: {
                        goods_id: data.goods_id,
                        number: data.number
                    }
                })
            },
            updateCart (index, type = 'addcart', range = [1, 99]) {
                let module = 'index.php/index/shopcar/' + type
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.getUserId()
                data.token = this.Local.getUserToken()
                data.lang = this.$i18n.locale
                data.goods_id = this.goods[index]['goods_id']
                data.number = 1

                if (type === 'delcart' && this.goods[index]['goods_num'] === range[0]) {
                    return false
                }
                if (type === 'addcart' && this.goods[index]['goods_num'] === range[1]) {
                    return false
                }

                this.$http.post(process.env.BASEURL + module, data)
                .then(function (response) {
                    if (parseInt(response.data.code) === 2000) {
                        if (type === 'addcart') {
                            this.goods[index]['goods_num'] += 1
                            if (this.goods[index]['goods_num'] > range[1]) {
                                this.goods[index]['goods_num'] = range[1]
                            }
                        } else {
                            this.goods[index]['goods_num'] -= 1
                            if (this.goods[index]['goods_num'] < range[0]) {
                                this.goods[index]['goods_num'] = range[0]
                            }
                        }
                    } else {
                        alert('网络错误')
                    }
                }.bind(this))
            },
            remove_order () {
                let index = this.goods_index
                let module = 'index.php/index/shopcar/delcart'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.getUserId()
                data.token = this.Local.getUserToken()
                data.lang = this.$i18n.locale
                data.goods_id = this.goods[index]['goods_id']
                data.number = this.goods[index]['goods_num']
                this.$http.post(process.env.BASEURL + module, data)
                .then(function (response) {
                    if (parseInt(response.data.code) === 2000) {
                        this.goods.splice(index, 1)
                        this.showdelect = false
                        this.$busEvent.$emit('order-count')
                    }
                }.bind(this))
            },
            selectAll (type) {
                for (let i in this.goods) {
                    if (type) {
                        this.goods[i]['if_checked'] = true
                    } else {
                        this.goods[i]['if_checked'] = false
                    }
                }
            },
            min (index) {
                this.updateCart(index, 'delcart', [
                    1,
                    this.goods[index]['store_count']
                ])
            },
            max (index) {
                this.updateCart(index, 'addcart',
                    [
                        1,
                        this.goods[index]['store_count']
                    ])
            },
            cancel (index) {
                for (let i in this.goods) {
                    if (index === this.goods[i].id) {
                        this.goods.splice(i, 1)
                    }
                }
            }

        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../scss/personal/shoppingCart";

    .order-groups {
        .order-header {
            display: flex;
            flex-wrap: nowrap;
            margin: 10px 0;
            span {
                flex: 1;
                font-size: 14px;
                color: #5E6D82;
                letter-spacing: 0;
                line-height: 20px;
            }
        }

    }
    .prifile-order-total{
        border: 1px solid #C0CCDA;
        padding: 15px 10px;
        .checkOut_btn{
            font-size: 20px;
            padding: 0;
            height: 40px;
            width: 150px;
        }
    }
    .canel_order{
        .page-content{
            text-align: center;
            padding: 10px 20px;
            .canel_order-title{
                h2{
                    font-size: 24px;
                    color: #1F2D3D;
                }
            }
            .canel_order_content{
                p{
                    max-width: 250px;
                    margin: 15px auto;
                }
            }
            .canel_order-btn{
                button{
                    margin-top: 5px;
                    border: 1px solid #0084FF;
                    border-radius: 5px;
                    background: transparent;
                    width: 140px;
                    padding: 5px 0;
                    color: #0084ff;
                }
                .ok_btn{
                    background: #0084FF;
                    color: white;
                }
            }
        }

    }
    .order-list {
        .order-row-header {
            font-size: 16px;
            color: #5E6D82;
            letter-spacing: 0;
            line-height: 24px;
        }
        .order-row {
            padding: 20px 0;
            background: #F9FCFF;
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            margin-bottom: 20px;
            & > div {
                flex: 1;
            }
            .order_item_group{
                max-width: 550px;
                overflow-x: scroll;
            }
            .goods-header {
                width: 140px;
                img {
                    width: 100%;
                }
            }
            .goods-desc {
                h3 {
                    font-size: 16px;
                    color: #1F2D3D;
                    letter-spacing: 0;
                    line-height: 24px;
                }
                p {
                    font-size: 16px;
                    color: #1F2D3D;
                    letter-spacing: 0;
                    line-height: 20px;
                    width: 100%;
                }
            }
            .goods-price{
               p{
                   font-size: 16px;
                   color: #1F2D3D;
                   letter-spacing: 0;
                   line-height: 20px;
                   width: 100%;
               }
            }
            .goods-price, .goods-num {
                font-size: 24px;
                color: #1F2D3D;
                letter-spacing: 0;
                line-height: 26px
            }
            .goods-num .goods-num-editable {
                display: flex;
                align-items: center;
                .number {
                    min-width: 20px;
                    display: inline-block;
                    text-align: center;
                    margin: 0 5px;
                    font-size: 16px;
                }
                button {
                    border: none;
                    padding: 3px 15px;
                    color: #fff;
                    i {
                        vertical-align: middle;
                    }
                }
                .minus {
                    border-bottom-left-radius: 5px;
                    border-top-left-radius: 5px;
                    background: #D3DCE6;
                    &:active {
                        background: darken(#D3DCE6, 10%)
                    }
                }
                .plus {
                    border-bottom-right-radius: 5px;
                    border-top-right-radius: 5px;
                    background-color: #0084FF;
                    &:active {
                        background: darken(#0084FF, 10%)
                    }
                }
            }
            .text-primary {
                color: #0084FF;
            }
            .goods-operation {
                font-size: 16px;
                letter-spacing: 0;
                line-height: 24px;
                a{
                    color: #1F2D3D;
                }
            }
        }
        .goods-checkbox {
            display: flex;
            margin-left: 8px;
            align-items: center;
        }

    }
    @media only screen and (max-width:768px) {
        .prifile-order-total .order-total-right{
            display: block;
        }
        .prifile-order-total .order-total-right button{
            font-size: 14px;
            width: 100px;
        }
        .prifile-order-total .order-calculate{
            font-size: 14px;
        }
        .pc-show{
            display: none;
        }
        .mobile-show{
            display: flex;
            margin: 15px;
            border-bottom: 1px solid #e6e6e6;
            .goods-header{
                width: 35%;
                img{
                    width: 100%;
                    max-width: 200px;
                    min-width: 100px;
                }
            }
            .goods-desc{
                width: 65%;
                padding-left: 20px;
                text-align: left;
                h3{
                    font-size: 16px;
                a{
                    float: right;
                    padding-right: 10px;
                }
                }
                p{
                    margin-right: 10px;
                    margin-bottom: 10px;
                    font-size: 14px;
                    border-bottom: 1px solid #e6e6e6;
                }
                .goods-num .goods-num-editable {
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                .number {
                    min-width: 20px;
                    display: inline-block;
                    text-align: center;
                    margin: 0 5px;
                    font-size: 14px;
                }
                .goods-price{
                    font-size: 16px;
                    padding-left: 25px;
                }
                button {
                    border: none;
                    padding: 3px 15px;
                    color: #fff;
                i {
                    vertical-align: middle;
                }
                }
                .minus {
                    border-bottom-left-radius: 5px;
                    border-top-left-radius: 5px;
                    background: #D3DCE6;
                    &:active {
                         background: darken(#D3DCE6, 10%)
                     }
                }
                .plus {
                    border-bottom-right-radius: 5px;
                    border-top-right-radius: 5px;
                    background-color: #0084FF;
                    &:active {
                         background: darken(#0084FF, 10%)
                     }
                }
                }
            }
        }
    }
    @media only screen and (min-width:768px) {
        .mobile-show{
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// ShoppingCart.vue?2179e59f